
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/level","xmlns":"http://www.w3.org/2000/svg","width":"11.342","height":"11.342","viewBox":"0 0 11.342 11.342"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fafbfc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M1.04 6.626a4.722 4.722 0 004.631 3.771 4.729 4.729 0 004.627-3.757"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.308 4.754a4.728 4.728 0 00-9.268-.038"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.38 5.671a.709.709 0 11-.709-.709.709.709 0 01.709.709z","opacity":".4"}})])])
          )
        }
      }
    